define(
    'widgets/fp_list_maintenance_grid/viewmodel',[
        "durandal/app",
        "providers/dataprovider",
        "extensions/kendo.extensions",
        "i19n!i19n/strings",
        "services/service.dialog"
    ],
    function (app, dataProvider, kendoExt, i19n, dialogService) {
    
        var Widget = function () {};

        Widget.prototype.activate = function (settings) {
            var self = this;

            self.i19n = i19n;
            
            self.settings = settings;
            self.notifications = ko.observableArray([]);
            self.isNotification = ko.computed(function () {
                return self.notifications().length != 0;
            });
            self.clearNotifications = function () {
                self.notifications([]);
            };
            self.notificationType = ko.observable('');
            self.notify = function (type, message) {
                if (arguments.length == 1) {
                    self.clearNotifications();

                    var r = arguments[0];
                    for (var i = 0; i < r.length; i++) {
                        self.notify(r[i].level, r[i].phrase);
                    }
                }

                if (arguments.length == 2 && (type != 'undefined' && message != 'undefined')) {
                    var t;

                    switch (type) {
                        case 1: t = 'alert-success'; break;
                        case 2: t = 'alert-warning'; break;
                        case 3: t = 'alert-danger'; break;
                        case 'error': t = 'alert-danger'; break;
                        case 'warning': t = 'alert-warning'; break;
                        case 'information': t = 'alert-info'; break;
                        case 'success': t = 'alert-success'; break;
                        default: t = 'alert-info';
                    }

                    self.notificationType(t);
                    self.notifications.push({ message: message });

                    tagForClearance(self.notifications().length, 10);

                    function tagForClearance(count, delay) {
                        var hwnd = setTimeout(function () {
                            if (self.notifications().length == count) {
                                self.clearNotifications();
                            }
                            if (self.notifications().length != count) {
                                //self.notifications().splice(self.notifications().length - count - 1, count);

                                clearTimeout(hwnd);
                            }
                        }, delay * 1000);
                    }
                }
            };
            self.closeNotification = function () {
                self.clearNotifications();
            };

            self.search_old = '';
            self.addRowData = null;
            self.addRow = function () {
                if (self.kendoGrid) {
                    var val = $("input#list-search-input").val();
                    if (val) {
                        self.search_old = val;
                        $("input#list-search-input").val("");
                        _filter("", self.kendoGrid);
                    }
                    var row = self.kendoGrid.dataSource.add();
                    var $row = self.kendoGrid.table.find('tr[data-uid="' + row.uid + '"]');

                    self.kendoGrid.select($row);
                    self.kendoGrid.editRow($row);

                    //var scrollContentOffset = self.kendoGrid.element.find("tbody").offset().top;
                    //var selectContentOffset = 0; //self.kendoGrid.select().offset().top;
                    //var distance = selectContentOffset - scrollContentOffset;

                    //self.kendoGrid.content.animate({ scrollTop: 0 }, 200);


                    //$("#list-values-grid").scrollTop(0);
                    //$("#list-values-grid").animate({scrollTop: 0});
                }
            };

            self.list = settings.data.list;
            self.listResults = settings.data.listResults;
            
            self.relatedListsMap = {};  

            self.resultCount = ko.computed(function () {                
                return self.listResults() != null ? self.listResults().values.length : 0;
            });
            self.isVisible = ko.computed(function () {
                return self.list() != null;
            });
            self.isReadOnly = ko.computed(function () {
                return self.list() != null && self.list().isReadOnly;
            });

            self.refresh = settings.data.refresh.extend({ notify: 'always' });
            self.refresh.subscribe(function (newValue) {
                if (newValue) {
                    self.initialize();
                }
            });

            self.load = settings.data.load.extend({ notify: 'always' });
            self.load.subscribe(function (listId) {
                if (!listId)
                    return;

                dataProvider.lists
                .getListResults(listId)
                .done(function (data) {
                    var deferreds = [];
                    var columns = _.map(data.columns, function (itm, i) {
                        if (itm.type.toLowerCase() == "foreignkey") {
                            itm.field = String.format("relatedListId{0}", i);

                            deferreds.push(
                                dataProvider.lists
                                .getListValues(itm.relatedList.listId)
                                .done(function (data2) {
                                    itm.relatedListLookupValues = data2;
                                })
                            );

                        }

                        return itm;
                    });
                    
                    $.when.apply(self, deferreds).always(function () {
                        var values = _.map(data.values, function (itm) {
                            var r = { listValueId: itm.listValueId };

                            _.each(itm.columnValues, function (itm2, i) {
                                var c = columns[i];

                                // related list values field, get the label description.
                                if (c.type.toLowerCase() == "foreignkey") {
                                    itm2 = _.map(itm2, function (listValueId) {
                                        return { listValueId: listValueId, label: getListValueDescription(c.relatedListLookupValues, listValueId) };
                                    });

                                    itm2 = _.sortBy(itm2, function (itm) { return itm.label; });
                                }

                                r[c.field] = itm2;
                            });

                            return r;
                        });                        

                        data.values = values;

                        self.listResults(data);
                        self.initialize();
                    });
                })
                .fail(function (e) {
                    console.error(e);
                });

                function getListValueDescription(relatedListLookupValues, listValueId) {
                    var relatedListValue = _.find(relatedListLookupValues, function (lookupValue) {
                        return lookupValue.listValueId == listValueId;
                    });

                    if (!relatedListValue)
                        return null;

                    return relatedListValue.label;
                }
            });
            self.isAdmin = ko.observable(settings.data.isAdmin);
            self.canEditListValues = ko.observable(settings.data.canEditListValues);

            self.exportClick = function () {
                //#region export init
                var columns = [];
                var rows = [];

                _.map(self.kendoGrid.columns, function (itm) {
                    if (!itm.command)
                        columns.push(itm);
                });

                var c = {};
                c.cells = [];

                _.map(columns, function (col) {                    
                    c.cells.push({ value: col.title });
                });

                rows.push(c);

                _.map(self.kendoGrid.dataSource.data(), function (row) {
                    var r = {};
                    r.cells = [];

                    _.map(columns, function (col) {
                        var val = row[col.field];

                        if (val[0] !== undefined && val[0].label !== undefined) {
                            var s = "";
                            for (var i = 0; i < val.length; i++) {
                                s = s + val[i].label + ", ";
                            }
                            val = s.substr(0, s.length - 2);                            
                        }

                        r.cells.push({ value: val });                        
                    });

                    rows.push(r);
                });
                //#endregion

                require(["services/service.documents"], function (documentsService) {
                    documentsService.actions.exportDocumentsXLS(rows, "List " + self.list().name + " " + kendo.toString(new Date(), "yyyy-MM-dd HH-mm"));
                });
            };
            self.exportCSVClick = function () {               
                require(["services/service.documents"], function (documentsService) {
                    documentsService.actions.exportListCSV(self.list().listId);
                });
            };
            self.importCSVClick = function () {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    var $import = $("#import-file-excel");

                    $import.unbind();

                    $import.replaceWith($import.val('').clone(true));

                    $import = $("#import-file-excel");
                    $import.bind("change", function (evt) {
                        var f = evt.target.files[0];
                        
                        if (f) {
                            require(["services/service.documents"], function (documentsService) {
                                console.warn("importing");
                                documentsService.actions.importListCSV(self.list().listId, f,
                                    function (data) {
                                        self.load(self.list().listId);

                                        self.notify('success', "List items imported");
                                    },
                                    function (e) {
                                        console.error(e);
                                        self.notify("Import failed");
                                    }
                                );
                            });
                            //var r = new FileReader();

                            //r.onload = function (e) {
                            //    var contents = e.target.result;
                            //    var drows = contents.split("\n");
                            //    var rows = [];

                            //    for (var i = 0; i < drows.length; i++) {
                            //        var row = {};
                            //        var dcells = drows[i].split(",");

                            //        for (var j = 0; j < dcells.length; j++) {
                            //            //row.push(cells[j]);
                            //            row[j] = dcells[j];
                            //        }

                            //        rows.push(row);
                            //    }

                            //    console.warn(rows);
                            //}

                            //r.readAsText(f);
                        } else {
                            alert("Failed to load file");
                        }




                        //var reader = new FileReader();

                        //reader.onload = function (e) {
                        //    var table = [];//$("<table />");
                        //    var rows = e.target.result.split("\n");

                        //    for (var i = 0; i < rows.length; i++) {
                        //        var row = []; //$("<tr />");
                        //        var cells = rows[i].split(",");
                        //        for (var j = 0; j < cells.length; j++) {
                        //            var cell = []; //$("<td />");
                        //            //cell.html(cells[j]);
                        //            row.push(cells[j]);
                        //        }
                        //        table.push(row);
                        //    }

                        //    //$("#dvCSV").html('');
                        //    //$("#dvCSV").append(table);
                        //    console.warn(table);
                        //}

                        //var f = evt.target.files[0];

                        //if (f) {
                        //    var r = new FileReader();

                        //    r.onload = function (e) {
                        //        var contents = e.target.result;
                        //        var drows = contents.split("\n");
                        //        var rows = [];

                        //        for (var i = 0; i < drows.length; i++) {
                        //            var row = {};
                        //            var dcells = drows[i].split(",");

                        //            for (var j = 0; j < dcells.length; j++) {
                        //                //row.push(cells[j]);
                        //                row[j] = dcells[j];
                        //            }

                        //            rows.push(row);
                        //        }

                        //        console.warn(rows);
                        //    }

                        //    r.readAsText(f);
                        //} else {
                        //    alert("Failed to load file");
                        //}

                        ////var f = evt.target.files[0];

                        ////if (f) {
                        ////    var r = new FileReader();
                        ////    r.onload = function (e) {
                        ////        var contents = e.target.result;
                        ////        console.warn("Got the file\n"+ "name: " + f.name + "\n"+ "type: " + f.type + "\n"+ "size: " + f.size + " bytes\n"+ "starts with: " + contents.substr(1, contents.indexOf("n")));
                        ////    }
                        ////    r.readAsText(f);
                        ////} else {
                        ////    alert("Failed to load file");
                        ////}
                    });
                    $import.click();
                } else {
                    alert('The File APIs are not fully supported by your browser.');
                }                                
            };
        };
        Widget.prototype.attached = function () {
            var self = this;

            self.$grid = $("#list-values-grid");
            self.$originalGrid = self.$grid.clone();
            self.list.valueHasMutated(); // the isVisible computed isn't running after the view had been attached, so forcing it.

            self.isAdmin(self.settings.data.isAdmin);
            self.canEditListValues(self.settings.data.canEditListValues);

            if (!self.listResults()) {
                $("#list-values-grid-toolbar-action").hide();
            } else {
                $("#list-values-grid-toolbar-action").show();
            }

            var debouncedFilter = _.debounce(function () { filter.call(this, self.kendoGrid); }, 400);
            $("input#list-search-input").on("keyup", debouncedFilter);            
        };
        Widget.prototype.initialize = function() {
            var self = this;
            
            self.relatedListsMap = {};            
            
            if (self.kendoGrid) {
                self.kendoGrid.destroy();
                self.kendoGrid = null;

                if (self.$grid) {
                    var $parent = self.$grid.parent();
                    var styles = self.$grid.attr("style"); // need this so the new grid re-orders columns and resizes and overflows correctly with scrollbars.

                    self.$grid.remove();
                    self.$grid = self.$originalGrid.clone();
                    self.$grid.attr("style", styles);

                    $parent.append(self.$grid);
                }                
            }

            self.isAdmin(self.settings.data.isAdmin);
            self.canEditListValues(self.settings.data.canEditListValues);

            if (!self.listResults()) {
                $("#list-values-grid-toolbar-action").hide();

                return;
            } else {
                $("#list-values-grid-toolbar-action").show();
            }                       

            self.buildKendoGrid(self.listResults().values, self.listResults().columns, { model: { id: "listValueId", fields: {} } });

            $(window).on("resize", _.debounce(function () { resizeGrid(self.$grid); }, 100));
        };
        Widget.prototype.buildKendoGrid = function (values, columns, schema) {
            var self = this;
            var $domElement = self.$grid, isReadOnly = self.isReadOnly(), cmd = [];
            
            //#region Grid Column
            columns = _.map(columns, function (itm, i) {
                if (itm.type.toLowerCase() == "foreignkey") {
                    itm.editor = getDropDownEditor(self, itm.field, itm.relatedListLookupValues);

                    self.relatedListsMap[itm.field] = itm.relatedList;
                }

                return itm;
            });

            columns = kendoExt.grid.addColumnTemplateFormatters(columns);

            _.each(columns, function (column) {
                schema.model.fields[column.field] = {};

                if (column.type.toLowerCase() !== "foreignkey") {
                    schema.model.fields[column.field].type = column.type;
                    schema.model.fields[column.field].validation = {
                        required: true,
                        "data-required-msg": String.format(i19n.to._isrequired, column.title)
                    };
                }

                if (column.field.toLowerCase() == "code")
                    column.width = 100;

                if (column.field.toLowerCase() == "description")
                    column.width = "auto";
            });

            if (self.settings.data.isAdmin) {
                cmd.push({
                    text: i19n.to.accesscontrol,
                    click: function (e) {
                        e.preventDefault();

                        var $row = $(e.currentTarget).closest("tr");
                        var row = this.dataItem($row);

                        this.select($row);

                        self.settings.data.accessControlShow(row.listValueId);

                        return false;
                    }
                });
            }
            if (self.settings.data.isAdmin || self.settings.data.canEditListValues) {
                cmd.push({
                    name: "edit",
                    text: i19n.to.edit,
                    click: function (e) {
                        var $row = $(e.target).closest("tr");
                        ////var data = this.dataItem($row);

                        this.select($row);
                        //this.editRow($row);

                        ////if (self.kendoGrid) {
                        ////    var row = self.kendoGrid.dataSource.add();
                        ////    var $row = self.kendoGrid.table.find('tr[data-uid="' + row.uid + '"]');

                        ////    self.kendoGrid.select($row);
                        ////    self.kendoGrid.editRow($row);
                        ////}

                        e.preventDefault();
                        e.stopPropagation();

                        return false;
                    }
                });
                cmd.push({ name: "destroy", text: i19n.to.delete });

                columns.push({
                    command: cmd,
                    title: "",
                    width: cmd.length > 2 ? 300 : 240
                });
            }

            //#endregion

            self.kendoGrid = $domElement.kendoGrid({
                dataSource: getKendoGridDataSource(self, self.$grid, self.list().listId, schema, values, self.relatedListsMap),
                dataBound: function () {
                    //$domElement.find(".k-button.k-button-icontext.k-grid-editItem > span").addClass("k-icon k-edit");
                },
                resizable: true,
                selectable: "row",
                reorderable: true,
                sortable: true,
                columns: columns,
                scrollable: {
                    virtual: true
                },
                editable: { mode: "popup", confirmation: false },
                cancel: self.clearNotification,
                edit: function (e) {
                    if (self.clearNotification)
                        self.clearNotification();

                    if (e.model.id.length == 0) {
                        $(".k-window-title").text("Add");
                    } else {
                        $(".k-window-title").text("Edit");
                    }
                },
                remove: self.clearNotification,
                save: self.clearNotification

            }).data("kendoGrid");            
        };

        //Widget.prototype.applyFilter = function () {
        //    var val = $("input#list-search-input").val();
        //    if (val) {
        //        _filter(val, self.kendoGrid);
        //    }
        //};

        return Widget;

        function resizeGrid($grid) {
            if (!$grid)
                return;

            var newGridHeight = $("#content-lists").outerHeight()
                - $(".page-header", "#content-lists").outerHeight()
                - $("#list-selection").outerHeight()
                - $("#list-values-grid-toolbar").outerHeight()
                - 35;

            $grid.height(newGridHeight);
            $grid.data("kendoGrid").resize();
        }

        function getKendoGridDataSource(self, $grid, listId, schema, listValues, relatedListsMap) {
            return new kendo.data.DataSource({
                transport: {
                    read: function (callbacks) {
                        callbacks.success(listValues);

                        resizeGrid($grid);
                    },
                    update: function (callbacks) {
                        persistData(callbacks.data, dataProvider.lists.updateListValue)
                        .done(function (result) {
                            self.notify('success', i19n.to.listitemupdated);

                            callbacks.success();
                        })
                        .fail(function (result) {
                            self.kendoGrid.cancelChanges();

                            result.stopPropagation = true;

                            self.notify(result.error);

                            callbacks.error(result.error);
                        });
                    },
                    create: function (callbacks) {
                        persistData(callbacks.data, dataProvider.lists.addListValue)
                        .done(function (result) {
                            self.notify('success', i19n.to.listitemadded);

                            callbacks.data["listValueId"] = result;
                            callbacks.success(callbacks.data);
                        })
                        .fail(function (result) {
                            self.kendoGrid.cancelChanges();
                            result.stopPropagation = true;

                            self.notify(result.error);

                            callbacks.error(result.error);
                        })
                        .always(function () {
                            $("input#list-search-input").val(self.search_old);
                            _filter(self.search_old, self.kendoGrid);

                            self.search_old = "";
                        });
                    },
                    destroy: function (callbacks) {
                        var dialogoptions = { ok: { label: 'Yes', message: '' }, cancel: { label: 'No', message: '' } };

                        dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.Code + ' ' + callbacks.data.Description + ' ?', _.toArray(dialogoptions))
                        .then(function (action) {
                            if (action == dialogoptions.cancel) {
                                self.kendoGrid.cancelChanges();
                            }
                            if (action == dialogoptions.ok) {
                                dataProvider.lists.deleteListValue(listId, callbacks.data.listValueId)
                                .done(function (result) {
                                    self.notify('success', i19n.to.listitemdeleted);

                                    callbacks.success();
                                })
                                .fail(function (result) {
                                    self.kendoGrid.cancelChanges();

                                    result.stopPropagation = true;

                                    self.notify(result.error);
                                    callbacks.error(result.error);
                                });
                            }
                        });
                    },
                },
                schema: schema,
                pageSize: 999
            });

            function persistData(data, updateFn) {
                var fieldMap = {};
                var relatedLists = [];

                _.each(data, function (value, key) {
                    if (key == "listValueId")
                        return;
                    else if (key.indexOf("relatedListId") !== -1) {
                        var listValueIds = _.map(value, function (listValue) {
                            return listValue.listValueId;
                        });

                        relatedLists.push({
                            listId: relatedListsMap[key].listId,
                            listRelationshipId: relatedListsMap[key].listRelationshipId,
                            listValueIds: listValueIds
                        });
                    } else {
                        fieldMap[key] = value;
                    }
                });

                return updateFn.call(dataProvider.lists, listId, fieldMap, relatedLists, data.listValueId);
            }
        }
        function getDropDownEditor(self, fieldName, relatedListLookupValues, onChange) {
            return function (container, options) {
                var currentValues = _.map(options.model[fieldName], function (listValue) {
                    return listValue.listValueId;
                });

                $("<select multiple='multiple'>")
                    .appendTo(container)
                    .kendoMultiSelect({
                        dataTextField: "label",
                        dataValueField: "listValueId",
                        value: currentValues || [],
                        dataSource: {
                            transport: {
                                read: function (callbacks) {
                                    relatedListLookupValues = relatedListLookupValues || [];
                                    relatedListLookupValues = _.sortBy(relatedListLookupValues, function (itm) { return itm.label; });

                                    callbacks.success(relatedListLookupValues);
                                },
                            }
                        },
                        change: function (e) {
                            var grid = $("#list-values-grid").data("kendoGrid");
                            var model = grid.dataItem(grid.select());

                            //if (!model) {
                            //    var row = this.element.closest("tr");
                            //    model = $("#list-values-grid").data("kendoGrid").dataItem(row);
                            //}

                            var uid = model.uid;

                            items = _.sortBy(this.dataItems(), function (itm) { return itm.label; });

                            model.set(fieldName, items);

                            grid.select(grid.tbody.find('tr[data-uid="' + uid + '"]'));
                        }
                    });
            };
        }               

        function filter(kendoGrid) {
            _filter(this.value, kendoGrid);
        }
        function _filter(value, kendoGrid) {
            if (!kendoGrid)
                return;

            var filteredColumns = _.filter(kendoGrid.options.columns, function (column) { return column.field; });
            var filters = _.map(filteredColumns, function (column) {
                return {
                    field: column.field,
                    operator: function (item, val) {
                        var searchText = "";

                        if (item instanceof kendo.data.ObservableArray && column.type.toLowerCase() == "foreignkey") {
                            _.each(item, function (arrayItem) {
                                searchText += arrayItem.label + " ";
                            });
                        } else {
                            searchText = column.formatter ? kendo.toString((item ? item.toString() : ""), column.formatter) : (item ? item.toString() : "");
                        }

                        return item != null && searchText.toLowerCase().indexOf(val.toLowerCase()) >= 0;

                    },
                    value: value //String.format("'{0}'", value)
                };
            });

            kendoGrid.dataSource.filter({
                logic: "or",
                filters: filters
            });
        }

});
